import { render, staticRenderFns } from "./UploadClientLogo.vue?vue&type=template&id=fe795f5a&"
import script from "./UploadClientLogo.vue?vue&type=script&lang=js&"
export * from "./UploadClientLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports